require('admin_login/bootstrap');

$(function () {
  if (top != self) {
    $('body').html('<p>This application can not be loaded in an iFrame</p>');
    return false;
  }

  var Backbone = require('backbone');
  var Login = require('admin_login');
  var LoginLayout = require('admin_login/layouts/login_layout');

  var login = new Login();
  var loginLayout = new LoginLayout();

  login.addRegions({
    LoginRegion: '#login-region',
  });

  login.LoginRegion.show(loginLayout);
  login.start();

  Backbone.history.start();
});
